import { observable } from 'mobx';
import useMount from '@src/utils/hooks/use-mount';
import copy from '@src/components/copy';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
const lang = getLanguageByPath();
const pageLocalesData = getPageLocalesData();
const textInfo = pageLocalesData.main.fourSection;

class FourSectionStore {
  constructor(props = {}) {
    Object.assign(this, { ...props });
  }
  @observable isActive = false;

  // 是否展示复制弹窗
  @observable isCopyModal = false;

  // 关闭弹窗
  closeCopyModal = () => {
    this.isCopyModal = false;
  };
  // 打开弹窗
  openCopyModal = () => {
    this.isCopyModal = true;
  };

  // 复制链接
  copyUrl = () => {
    // https://pp-zt.xoyo.games/mechabreak.seasungames.com/p/zt/2024/12/19/dlc/  短链：https://mechabreak.seasungames.com/
    // window.location.href
    copy(`https://mechabreak.seasungames.com/${lang}/`, {
      showText: false,
      successPreText: `${textInfo.moveMap.copyText}`
    });
  };

  use() {
    useMount(async () => {
      // this.clickIndex(1);
    });
  }
}

export default FourSectionStore;
